import React from 'react'
import { Radio } from './dashboard-form'

const VisibilitySelector = ({form, updateForm}) => {
  return (
    <div className="flex flex-wrap -mx-2 mb-2 lg:mb-0">
      <div className="w-1/2 px-2 lg:w-full mb-4 lg:mb-0">
        <Radio
          name="visibility"
          id="visibility1"
          label="Public"
          value="public"
          className="mb-1"
          form={form}
          onChange={updateForm}
        />
      </div>
      <div className="w-1/2 px-2 lg:w-full mb-4 lg:mb-0">
        <Radio
          name="visibility"
          id="visibility2"
          // label="Verified User"
          label="Member"
          value="verified"
          className="mb-1"
          form={form}
          onChange={updateForm}
        />
      </div>
      <div className="w-1/2 px-2 lg:w-full mb-4 lg:mb-0">
        <Radio
          name="visibility"
          id="visibility3"
          label="Organization"
          value="organization"
          form={form}
          onChange={updateForm}
        />
      </div>
    </div>
  )
}

export { VisibilitySelector }
